<template>
  <div class="quiz_result">
    <div class="quiz_result_bg"></div>
    <div class="quiz_result_incorrect">
      <div class="quiz_result_incorrect_content">
        <div class="quiz_result_incorrect_content_image"></div>
        <quiz-button :hint_url="hint_url" text="ヒントはこちら" @clickQuizButton="clickQuizButtonHandler(qm_id)"/>
        <quiz-close-button @closeClick="closeClickHandler" />
      </div>
    </div>
  </div>
</template>

<script>
import QuizButton from '@/components/QuizButton'
import QuizCloseButton from '@/components/QuizCloseButton'
import HintClickable from '@/components/mixins/HintClickable'

export default {
  name: 'QuizResultIncorrectDialog',
  mixins: [HintClickable],
  components: {
    QuizCloseButton,
    QuizButton
  },
  props: {
    qm_id: {
      type: Number,
      required: true
    },
    hint_url: {
      type: String,
      required: true
    }
  },
  methods: {
    closeClickHandler () {
      this.$emit('closeClick')
    }
  }
}
</script>

<style scoped>
  .quiz_result_incorrect {
    background: #8dc9ed;
    position: relative;
    padding: 10px 10px 51px;
    border-radius: 48px 0 48px 0;
    width: 700px;
    min-width: 700px;
  }

  @media screen and (max-width: 767px) {
    .quiz_result_incorrect {
      margin: 0 3%;
      width: 100%;
      min-width: auto;
    }
  }

  .quiz_result_incorrect_content {
    background: #fff;
    position: relative;
    padding: 10px 10px 0;
    border-radius: 48px 0 48px 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .quiz_result_incorrect_content:after {
    background: url("../assets/quiz_pop_bad_deco.png") no-repeat center;
    content: "";
    width: 643px;
    height: 60px;
  }

  @media screen and (max-width: 767px) {
    .quiz_result_incorrect_content:after {
      background-size: contain;
      width: 100%;
      height: 0;
      padding-top: 9%;
    }
  }

  .quiz_result_incorrect_content_image {
    background: url("../assets/quiz_pop_bad.png") no-repeat center;
    width: 520px;
    height: 200px;
  }

  @media screen and (max-width: 767px) {
    .quiz_result_incorrect_content_image {
      background-size: contain;
      width: 70%;
      height: 0;
      padding-top: 28%;
    }
  }

  .quiz_result {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  @media screen and (max-width: 767px) {
    .quiz_result {
      overflow: auto;
      -webkit-box-align: start;
      -webkit-align-items: flex-start;
      -ms-flex-align: start;
      align-items: start;
      padding-top: 3%;
    }
  }

  .quiz_result_bg {
    background: #000;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.2;
  }
</style>
